
const digest = '0d456feb656e8e046e282ecd96d70670fb9ce2fe11f739c9b562849f236fe58e';
const classes = {"wrapper":"_wrapper_1mji7_1","item":"_item_1mji7_6","titleWrapper":"_titleWrapper_1mji7_18","title":"_title_1mji7_18"};
const css = `._wrapper_1mji7_1 {
  font-family: Rubik, "sans-serif";
  display: flex;
  flex-direction: column;
}
._wrapper_1mji7_1 ._item_1mji7_6 {
  font-weight: 400;
  font-size: 14px;
  padding: 16px 24px;
  background-color: #ffffff;
  margin-bottom: 5px;
  color: #000000;
  display: flex;
  flex-direction: column;
  gap: 12px;
  border: 1px solid #eaedf3;
}
._wrapper_1mji7_1 ._item_1mji7_6 ._titleWrapper_1mji7_18 {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
._wrapper_1mji7_1 ._item_1mji7_6 ._titleWrapper_1mji7_18 ._title_1mji7_18 {
  font-weight: 600;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  